// extracted by mini-css-extract-plugin
module.exports = {"IconList":"IconList_IconList__t8Et5"};